import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get_documents_for_meeting, download_document } from '../actions';
import Agenda from './agenda';

import '../global';

class Documents extends Component {

	constructor( props ) {
		super( props );
		this.state = { error: false };

	}

	errorLogin() {
		this.setState( { error: true } );
	}

	componentWillMount() {
		this.props.get_documents_for_meeting();
	}

	handleClick( file_name, download_file_name ) {
		this.props.download_document( file_name, download_file_name );
	}

	getDocumentsHTML() {
		let documents = [];
		if ( this.props.meeting_materials !== false ) {
			if ( this.props.meeting_materials.data.attachments.length <= 0 ) {
				documents = (
					<div class="no-documents">No documents available for this meeting.</div>
				);
			} else {
				if ( this.props.committee_participant === true ) {
					documents = this.props.meeting_materials.data.attachments.map( attachment => (

						<li>
							<i class="glyphicon glyphicon-download"></i>
							<div class="attachment-link" onClick={ this.handleClick.bind( this, attachment.file_name, attachment.download_file_name ) } data-meet-id={ this.props.meet_id } data-category={ attachment.category } data-document-id={ attachment.ID }>{ attachment.download_file_name }</div>
						</li>
					) );
				} else {
					documents = this.props.meeting_materials.data.attachments.map( attachment => (
						<li><i class="glyphicon glyphicon-download"></i>
							<div class="attachment-link" onClick={ this.errorLogin.bind( this ) } data-meet-id={ this.props.meet_id } data-category={ attachment.category } data-document-id={ attachment.ID }>{ attachment.download_file_name }</div>
						</li>
					) );
				}
			}

		}

		return documents;
	}

	handleLogin() {
		location.reload();
	}

	render() {
		if( this.props.committee_participant !== true ){
			return ('');
		}
		let error = '';
		if(this.props.expired_token === true){
			return (<div></div>);
		}
		if ( this.state.error === true ) {
			error = (<div class="document-error ">
					Your email address or login is not associated with this committee.
					<br />For technical assistance, please contact the
					<a href={ 'mailto:' + getContactEmail() }>ISDA Staff Contact</a>.
				</div>
			);
		}
		return (<div class="meeting-documents-container">
			{ error }
			<span>Meeting Documents:</span>
			<ul>
				{ this.getDocumentsHTML() }
			</ul>
			<Agenda />
		</div>
		);
	}

}

function mapStateToProps( { meeting_materials, committee_participant, expired_token } ) {
	return { meeting_materials, committee_participant, expired_token };
}

export default connect( mapStateToProps, {
	get_documents_for_meeting,
	download_document
} )( Documents );